const device = () => {
	const breakpoint = document.querySelector('.breakpoint');
	const breakpointContent = !breakpoint
		? undefined
		: window
				.getComputedStyle(breakpoint, ':before')
				.getPropertyValue('content')
				.replace(/"/g, '');

	return breakpointContent;
};

export default device;
